"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

const $Container = _styledComponents.default.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 55px;
  padding: ${_blocks.spacing.snug};
  background-color: ${_blocks.palette.neutral2};
`;
const StyledSupportingText = (0, _styledComponents.default)(_blocks.SupportingText)`
  margin-right: ${_blocks.spacing.snug};
`;

const MenuFooter = ({
  onCancel,
  onConfirm,
  isConfirmDisabled,
  isZeroSites
}) => /*#__PURE__*/_react.default.createElement($Container, null, isZeroSites && /*#__PURE__*/_react.default.createElement(StyledSupportingText, null, _core.i18n._({
  id: 'site_menu.select_site_prompt',
  message: `At least one site must be selected`
})), /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
  tight: true
}, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
  thin: true,
  appearance: "plain",
  onClick: onCancel
}, _core.i18n._({
  id: 'site_menu.cancel',
  message: `Cancel`
})), /*#__PURE__*/_react.default.createElement(_blocks.Button, {
  primary: true,
  thin: true,
  disabled: isConfirmDisabled,
  onClick: onConfirm
}, _core.i18n._({
  id: 'site_menu.update',
  message: `Update`
}))));

MenuFooter.propTypes = {
  onCancel: _propTypes.default.func.isRequired,
  onConfirm: _propTypes.default.func.isRequired,
  isConfirmDisabled: _propTypes.default.bool.isRequired,
  isZeroSites: _propTypes.default.bool.isRequired
};
var _default = MenuFooter;
exports.default = _default;
module.exports = exports.default;